export const suketana = {
  slug: "suketana",
  name: "Suketana",
  location: "Cherukupally village, Shadnagar",
  approval: "Approved plotted layout",
  acreage: "Premium open-plot venture",
  status: "Site visits available",
  logo: "/projects/suketana/logo.png",
  hero: "/projects/suketana/aerial-amenities.webp",
  summary:
    "A calm open-plot community where nature, lifestyle amenities, and future value are presented together.",
  description:
    "Suketana has the strongest lifestyle imagery, so the page should emphasize family-friendly amenities, greenery, internal roads, security, and weekend-home comfort.",
  layoutImages: [{ src: "/projects/layouts/Suketana-Layout.webp", alt: "Suketana layout preview", label: "Layout preview" }],
  approvalImages: [],
  featuredImages: [
    {
      src: "/projects/suketana/kids-play-area.webp",
      alt: "Suketana kids play area",
      title: "Family-first amenities",
      copy: "The play area is a strong visual proof point for families considering weekend-home or future residential use."
    },
    {
      src: "/projects/suketana/cricket-net.webp",
      alt: "Suketana cricket net",
      title: "Active outdoor living",
      copy: "Sports amenities support the brand story around safe, healthy, and happy living."
    },
    {
      src: "/projects/suketana/walkway-lawn.webp",
      alt: "Suketana walkway lawn",
      title: "Green community feel",
      copy: "Lawns, pergolas, and walkways align directly with the founder's nature-led positioning."
    }
  ],
  galleryImages: [
    ["/projects/suketana/aerial-amenities.webp", "Aerial amenities and entrance"],
    ["/projects/suketana/aerial-entrance.webp", "Aerial entrance view"],
    ["/projects/suketana/internal-road.webp", "Internal blacktop road"],
    ["/projects/suketana/water-tower-road.webp", "Water tower and road"],
    ["/projects/suketana/cricket-net.webp", "Cricket net"],
    ["/projects/suketana/entrance-gate.webp", "Entrance gate"],
    ["/projects/suketana/water-tower.webp", "Water tower"],
    ["/projects/suketana/kids-play-area.webp", "Kids play area"],
    ["/projects/suketana/gazebo.webp", "Gazebo"],
    ["/projects/suketana/walkway-lawn.webp", "Walkway lawn"],
    ["/projects/suketana/pergola.webp", "Pergola"],
    ["/projects/suketana/security-room.webp", "Security room"],
    ["/projects/suketana/playground.webp", "Playground"],
    ["/projects/suketana/animal-sculpture.webp", "Animal sculpture garden"],
    ["/projects/suketana/blacktop-road.webp", "Blacktop road"]
  ],
  facts: [["Location", "Cherukupally"], ["Asset", "Open plots"], ["Visit", "By appointment"], ["Focus", "Lifestyle"]],
  amenities: ["Kids play area", "Cricket net", "Gazebo", "Security room", "Landscaped greens"]
};
